import React from 'react'
import styled from 'styled-components'

import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Text = styled(Paragraph)`
  margin-bottom: 48px;
`

const ItemsRow = styled.div`
  display: flex;
  column-gap: 16px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Item = styled.div`
  width: 100%;
  padding: 16px;
  border: 1px solid #e6e2fc;
  border-radius: 4px;
`

const Icon = styled.div`
  width: 64px;
  margin-bottom: 8px;
  min-height: 64px;
  img {
    width: 100%;
  }
`

const ItemHeading = styled.div`
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 20px;
  line-height: 170%;
`

const ItemText = styled(Paragraph)``

const Iconography = () => {
  return (
    <>
      <Heading>Iconography</Heading>
      <Text>
        We use iconography to help illustrate and breakdown our product information. Please see our icon library for
        more information.
      </Text>
      <ItemsRow>
        <Item>
          <Icon>
            <img src="/images/icon-chat.svg" alt="" />
          </Icon>
          <ItemHeading>Chat rooms</ItemHeading>
          <ItemText>
            Chat rooms and contact sharing to assist networking between attendees and connect remote and live visitors
          </ItemText>
        </Item>
        <Item>
          <Icon>
            <img src="/images/icon-feeds.svg" alt="" />
          </Icon>
          <ItemHeading>Activity feeds</ItemHeading>
          <ItemText>
            Activity feeds which display upcoming activities, announcements, comments from viewers, interactions and
            on-floor photo sharing
          </ItemText>
        </Item>
      </ItemsRow>
      <ItemsRow>
        <Item>
          <Icon>
            <img src="/images/icon-presence.svg" alt="" />
          </Icon>
          <ItemHeading>Presence Indicators</ItemHeading>
          <ItemText>
            Presence indicators to mimic the social buzz of an in-person event for streamers and allow all visitors to
            see who else has joined
          </ItemText>
        </Item>
        <Item>
          <Icon>
            <img src="/images/icon-qas.svg" alt="" />
          </Icon>
          <ItemHeading>Q&As</ItemHeading>
          <ItemText>Q&As for engagement with heavyweight speakers, VIP performers and fellow attendees</ItemText>
        </Item>
      </ItemsRow>
    </>
  )
}

export default Iconography
